import React from 'react';
import { Link } from 'react-router-dom';

const AdItem = ({ ad }) => {
  const { connect_link, image, title, description } = ad;

  const isExternalLink =
    connect_link.startsWith('http://') ||
    connect_link.startsWith('https://') ||
    connect_link.startsWith('www.');

  const href = isExternalLink
    ? connect_link.startsWith('http') ? connect_link : `http://${connect_link}`
    : connect_link.startsWith('/') ? connect_link : `/${connect_link}`;

  const Wrapper = ({ children }) =>
    isExternalLink ? (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-none text-dark d-flex flex-column h-100"
      >
        {children}
      </a>
    ) : (
      <Link
        to={href}
        className="text-decoration-none text-dark d-flex flex-column h-100"
      >
        {children}
      </Link>
    );

  return (
    <div className="lst-item box-link hover p-2 w-100 d-flex flex-column">
      <Wrapper>
        <div className="d-flex flex-column flex-md-row align-items-start gap-2">
          <div className="flex-shrink-0 text-center">
            <img
              src={image || '/images/photos/no_image.png'}
              alt={title || 'product'}
              title={title || 'product'}
              style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: 8 }}
            />
          </div>
          <div className="flex-grow-1 w-100">
            <h6 className="fw-bold text-wrap mb-1">{title}</h6>
            <p>{description}</p>
          </div>
        </div>
        <small className="opacity-50 d-block mt-auto text-end">Được tài trợ</small>
      </Wrapper>
    </div>
  );
};

export default AdItem;
